import React from 'react';
import * as mainActions from './../actions/actions';
import mainStore from '../stores/mainStore';
import '../App.css';
class SignUp extends React.Component{
    constructor(){
        super();
        this.state={
            email:'',
            registerResponse:false,
            emailValidation:false
        }

        this.handleChangs=this.handleChange.bind(this)
    }

    componentWillMount(){
        mainStore.on('changeRegister',this.handleChangs)
    }

    componentDidMount() {
        document.addEventListener('keydown', this.onEnter);
    }

    componentWillUnmount(){
        mainStore.removeListener('changeRegister',this.handleChangs)
        document.removeEventListener('keydown', this.onEnter);
    }

    onEnter = e => {
        if (e.keyCode === 13) {
            this.register();
        }
    };

    handleChange(){
        console.log(mainStore.state.registerResponse)

        if(mainStore.state.registerResponse){
            this.setState({registerResponse:mainStore.state.registerResponse.data})
            setTimeout(()=>{
                this.setState({
                    registerResponse:false
                })
            },3000)
        }


    }
    updateFullNameValue(event){
        this.setState({
            full_name:event.target.value
        })
    }
    updateEmailValue(event){
        this.setState({
            email:event.target.value
        })
    }
    updatePasswordValue(event){
        this.setState({
            password:event.target.value
        })
    }
    updateCountryValue(event){
        this.setState({
            country:event.target.value
        })
    }
    updatePhoneValue(event){
        this.setState({
            phone_number:event.target.value
        })
    }
    register(){
        this.setState({registerResponse:false,emailValidation:false})
        if(this.state.email){
            mainActions.register(this.state);
        }else{
            this.setState({
                emailValidation:true
            })
        }
    }


    render(){
        let alert=this.state.registerResponse

        return (
            <div class="tab-pane fade show active" id="register" role="tabpanel" aria-labelledby="register-tab">
                <form class="needs-validation" novalidate>

                    <div class="form-group">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text rounded-0" id="email-register-addon"><i class="fas fa-at"></i></span>
                            </div>
                            <input type="email"
                             value={this.state.email}
                             onChange={this.updateEmailValue.bind(this)}
                            class="form-control rounded-0" placeholder="Email" aria-describedby="email-register-addon" required/>
                            {this.state.emailValidation&&!this.state.email?
                            <div class="invalid-feedback">
                                    This field is required
                            </div>:null}
                        </div>
                    </div>


                {!alert?<div></div>:
                    <span>
                    {alert.status==='error'?<div class="alert alert-danger alert-dismissible fade show rounded-0" role="alert">
                    <strong class="d-block">{alert.alert.title}</strong>{alert.alert.description}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" onClick={()=>this.setState({registerResponse:false})}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    </div>:<div class="alert alert-success alert-dismissible fade show rounded-0" role="alert">
                    <strong class="d-block">{alert.alert.title}</strong>{alert.alert.description}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" onClick={()=>this.setState({registerResponse:false})}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    </div>}
                    </span>
                }



                    <button type="button" class="btn btn-warning rounded-0 pull-right" style={{textTransform:"none"}} onClick={()=>this.register()}>Sign Up NOW</button>
                </form>
            </div>

        )
    }
}


export default SignUp;
